module.exports = __webpack_public_path__ + "img/expo2018.36b8db12.jpg";